"use client";

import _slicedToArray from "/codebuild/output/src3481540116/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMenuContext } from "./B2J376ND.js";
import { useMenubarContext } from "./62UHHO2X.js";
import { useComboboxProviderContext } from "./VEVQD5MH.js";
import { useCompositeStoreProps } from "./4CMBR7SL.js";
import { useHovercardStoreProps } from "./FTXTWCCT.js";
import { useStore, useStoreProps } from "./YV4JVR4I.js";
import { useUpdateEffect } from "./ABQUS43J.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/menu/menu-store.ts
import * as Core from "@ariakit/core/menu/menu-store";
function useMenuStoreProps(store, update, props) {
  useUpdateEffect(update, [props.combobox, props.parent, props.menubar]);
  useStoreProps(store, props, "values", "setValues");
  return Object.assign(useHovercardStoreProps(useCompositeStoreProps(store, update, props), update, props), {
    combobox: props.combobox,
    parent: props.parent,
    menubar: props.menubar
  });
}
function useMenuStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parent = useMenuContext();
  var menubar = useMenubarContext();
  var combobox = useComboboxProviderContext();
  props = __spreadProps(__spreadValues({}, props), {
    parent: props.parent !== void 0 ? props.parent : parent,
    menubar: props.menubar !== void 0 ? props.menubar : menubar,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  });
  var _useStore = useStore(Core.createMenuStore, props),
    _useStore2 = _slicedToArray(_useStore, 2),
    store = _useStore2[0],
    update = _useStore2[1];
  return useMenuStoreProps(store, update, props);
}
export { useMenuStoreProps, useMenuStore };